export const events: TableModule = {
    name: "events",
    route: "spa.events.events",
    defaultOrder: {
        column: "events.start_date",
        direction: "desc"
    },
    columns: [
        {
            name: "name",
            sortable: true,
            pageLink: true,
            mobile: true
        },
        {
            name: "dates",
            sortable: true,
            sortBy: "events.start_date",
            width: "w-[200px]"
        },
        {
            name: "progress",
            sortable: false,
        },
        {
            name: "status",
            sortable: false,
            mobile: true,
            truncate: false,
            width: "w-1/3 sm:w-[125px]"
        }
    ],
    filters: [
        {
            name: "id",
            column: "events.id",
            type: "numeric"
        },
        {
            name: "name",
            column: "events.name",
            type: "string",
            reduced: true
        },
        {
            name: "start_date",
            column: "events.start_date",
            type: "date",
            reduced: "date[,]"
        },
        {
            name: "reminders",
            column: "events.reminders",
            type: "boolean"
        },
        {
            name: "active",
            column: "events.active",
            type: "boolean"
        }
    ],
    quickFilters: [
        {
            name: "qf_onlyActive",
            column: "events.active",
            value: [1],
            operator: "="
        }],
    tools: [
        {
            isCreateAction: true,
            ability: ["create", "events"]
        }
    ]
}